import { useToastContext } from "components/alert/ToastContext";
import BaseListagem from "components/BaseListagem";
import ReportEdit from "components/reports/ReportEdit";
import Pessoa from "model/administracao/cadastro/Pessoa";
import Produto from "model/administracao/cadastro/produto/Produto";
import Local from "model/patrimonio/Local";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Column, ColumnFilterElementTemplateOptions } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import saveAs from 'file-saver';
import { Dropdown } from "primereact/dropdown";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useState } from "react";
import ProdutoService from "service/administracao/cadastro/produto/ProdutoService";
import PatrimonioService from "service/patrimonio/PatrimonioService";
import { converterDataHora } from "utils/convert";
import { dateFilterTemplate, DateMatchModeOptions, decimalFilterTemplate, filterApplyTemplate, IdMatchModeOptions, ListMatchModeOptions, NumberMatchModeOptions, ProdutoFilterTemplate, statusFilterTemplate, TextMatchModeOptions } from "utils/filterUtils";
import { SplitButton } from "primereact/splitbutton";
import { Button } from "primereact/button";
import UsuarioLogadoService from "service/usuario/UsuarioLogadoService";
import Patrimonio from "model/patrimonio/Patrimonio";

const patrimonioService = new PatrimonioService();
const usuarioLogadoService = new UsuarioLogadoService();

export default function PatrimonioListagem() {

    const { msgErro } = useToastContext();

    const { startLoading, stopLoading } = useLoadingContext();

    const [produtos, setProdutos] = useState<Produto[]>([]);
    const [locais, setLocais] = useState<Local[]>([]);
    const [fornecedores, setFornecedores] = useState<Pessoa[]>([]);

    const [editaRelatorio, setEditaRelatorio] = useState<boolean>(false);
    const [visibleEditarRelatorio, setVisibleEditarRelatorio] = useState<boolean>(false);

    useEffect(() => {
        patrimonioService.produtos().then(lista => {
            setProdutos(lista);
        }).catch(err => {
            console.log(err);
        });
    }, []);
    useEffect(() => {
        patrimonioService.locais().then(lista => {
            setLocais(lista);
        }).catch(err => {
            console.log(err)
        });
    }, []);
    useEffect(() => {
        patrimonioService.fornecedores().then(lista => {
            setFornecedores(lista);
        }).catch(err => {
            console.log(err)
        });
        usuarioLogadoService.getAcoesUsuarioLogado().then((resposta) => {
            setEditaRelatorio(usuarioLogadoService.usuarioTemAcao(resposta, "RELATORIO_PATRIMONIO_LISTAGEM"));
        }).catch((erro) => {
            console.log(erro);
        });
    }, []);


    const defaultFilters: DataTableFilterMeta = {
        codigo: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        produto: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        local: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        fornecedor: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        preco: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        status: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.IN,
                }
            ],
            operator: FilterOperator.AND
        },
        dataRecebimento: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        }


    }

    const [filters, setFilters] = useState<DataTableFilterMeta>(defaultFilters);

    const getRelatorioListagem = () => {
        startLoading();
        patrimonioService.getRelatorioListagem(filters).then((response) => {
            stopLoading();
            const file = new Blob([response], { type: 'application/pdf' });
            saveAs(file, "patrimonios.pdf");
        }).catch((err) => {
            stopLoading();
            msgErro("Relatório", "Erro ao gerar relatório")
            console.log(err);
        })
    }

    const getRelatorio = (patrimonio : Patrimonio) => {
        startLoading();
        patrimonioService.getRelatorio(patrimonio.id).then((response) => {
            stopLoading();
            const file = new Blob([response], { type: 'application/pdf' });
            saveAs(file, `Relatório Patrimônio ${patrimonio.codigo}.pdf`);
        }).catch((err) => {
            stopLoading();
            msgErro("Relatório", "Erro ao gerar relatório")
            console.log(err);
        })
    }

    const botoesExtra = () => {
        const model = editaRelatorio
            ? [{ label: "Editar relatórios", icon: "pi pi-pencil", command: () => setVisibleEditarRelatorio(true) }]
            : [];

        const botaoRelatorio = editaRelatorio ? (
            <SplitButton
                key="btn2"
                label="Relatório"
                icon="pi pi-file-pdf"
                style={{marginRight: 8}}
                onClick={() => getRelatorioListagem()}
                model={model}
            />
        ) : (
            <Button
                key="btn2"
                label="Relatório"
                icon="pi pi-file-pdf"
                style={{marginRight: 8}}
                onClick={() => getRelatorioListagem()}
            />
        );

        return [botaoRelatorio];
    };

    const dialogEditarRelatorio = (
        <Dialog header="Editar relatório" visible={visibleEditarRelatorio} onHide={() => setVisibleEditarRelatorio(false)} >
            {editaRelatorio ? <ReportEdit nomeAcao="RELATORIO_PATRIMONIO_LISTAGEM" titulo="Relatório dos Patrimonios" testarRelatorio={() => { }} style={{ marginBottom: 10 }} /> : null}
        </Dialog>
    )

    const localFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <Dropdown value={options.value} options={locais}
            onChange={(e) => options.filterCallback(e.value)}
            optionLabel="nome" optionValue="id" placeholder="Qualquer" className="p-column-filter" />
    }

    const fornecedorFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <Dropdown value={options.value} options={fornecedores}
            onChange={(e) => options.filterCallback(e.value)}
            optionLabel="nome" optionValue="id" placeholder="Qualquer" className="p-column-filter" />
    }

    return (
        <>
            {dialogEditarRelatorio}
            <BaseListagem
                buttonsExtra={botoesExtra()}
                ordenacao="codigo,DESC"
                service={patrimonioService}
                urlService="/patrimonio"
                tituloPagina={'Patrimônios'}
                defaultFilters={defaultFilters}
                showClearFilterButton
                nome="patrimonio"
                onChangeFilters={(filters) => setFilters(filters)}
            >
                <Column field="codigo" header="Código" sortable sortField='codigo' filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate}
                    headerStyle={{ width: "8%" }} />
                <Column field="produto.nome" header="Produto" filter sortable sortField='produto.nome' showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="produto"
                    filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate}
                    headerStyle={{ width: "20%" }} />
                <Column field="local.nome" header="Local" filter sortable sortField='local.nome' showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="local"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={localFilterTemplate}
                    headerStyle={{ width: "20%" }} />
                <Column field="fornecedor.nome" header="Fornecedor" filter sortable sortField='fornecedor.nome' showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="fornecedor"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={fornecedorFilterTemplate}
                    headerStyle={{ width: "20%" }} />
                <Column field="preco" header="Preço" filter sortable sortField='preco' showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={NumberMatchModeOptions} filterApply={filterApplyTemplate} filterElement={decimalFilterTemplate}
                    headerStyle={{ width: "10%" }} />
                <Column field="status" header="Status" body={(rowData) => patrimonioService.getStatus(rowData.status)} filter sortable sortField='status' showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={ListMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => statusFilterTemplate(options, patrimonioService.getListaStatusFilter())}
                    headerStyle={{ width: "14%" }} />
                <Column field="dataRecebimento" body={(rowData) => rowData.dataRecebimento ? converterDataHora(rowData.dataRecebimento) : ""} header="Data Recebimento" style={{ width: '10em' }}
                    filter sortable sortField='dataRecebimento' showFilterOperator={false} showAddButton={false}
                    filterMatchModeOptions={DateMatchModeOptions}
                    filterApply={filterApplyTemplate} filterElement={dateFilterTemplate} filterMenuStyle={{ zIndex: 50 }} />
                <Column body={(rowData) => {
                    return <Button icon="pi pi-file-pdf" onClick={() => {
                        getRelatorio(rowData);
                    }} />
                }} header="Relatório" />
            </BaseListagem>
        </>
    )
}